
import { Identity } from "../types";

export interface HistoryResponse {
  success: boolean;
  history: Identity[];
  quota?: number;
  used_quota?: number;
}

export const historyService = {
  async fetchHistory(username: string): Promise<HistoryResponse> {
    try {
      const res = await fetch(`/api/history?username=${encodeURIComponent(username)}`);
      
      if (res.status === 404 || res.status === 403) {
        throw new Error("SESSION_EXPIRED");
      }
      
      const data = await res.json();
      return data;
    } catch (e: any) {
      if (e.message === "SESSION_EXPIRED") throw e;
      console.error("加载历史失败", e);
      return { success: false, history: [] };
    }
  },

  async saveHistory(username: string, identity: Identity): Promise<boolean> {
    try {
      const res = await fetch(`/api/history?username=${encodeURIComponent(username)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identity })
      });

      if (res.status === 404 || res.status === 403) {
        throw new Error("SESSION_EXPIRED");
      }

      const data = await res.json();
      return data.success;
    } catch (e: any) {
      if (e.message === "SESSION_EXPIRED") throw e;
      console.error("保存历史失败", e);
      return false;
    }
  },

  async clearHistory(username: string): Promise<boolean> {
    try {
      const res = await fetch(`/api/history?username=${encodeURIComponent(username)}`, {
        method: 'DELETE'
      });

      if (res.status === 404 || res.status === 403) {
        throw new Error("SESSION_EXPIRED");
      }

      const data = await res.json();
      return data.success;
    } catch (e: any) {
      if (e.message === "SESSION_EXPIRED") throw e;
      console.error("清空历史失败", e);
      return false;
    }
  }
};
